const updateProfileScrollables = () => {
  document.querySelectorAll('.profile__item').forEach((item) => {
    const text = item.querySelector('.profile__text');
    if (!text) return;

    const threshold = parseFloat(getComputedStyle(item).paddingBottom) || 0;

    const isScrollable =
      !item.classList.contains('jury__item') &&
      text.scrollHeight > text.clientHeight + threshold;
    item.classList.toggle('is-scrollable', isScrollable);
  });
};

updateProfileScrollables();
window.addEventListener('resize', updateProfileScrollables);
window.addEventListener('load', updateProfileScrollables);

window.updateProfileScrollables = updateProfileScrollables;

let profileDrag = null;

const getProfileDragTarget = (item, clientX, clientY) => {
  if (!item.classList.contains('is-scrollable')) return null;
  const text = item.querySelector('.profile__text');
  const photo = item.querySelector('.profile__photo');
  if (!text || !photo) return null;
  const itemRect = item.getBoundingClientRect();
  const photoRect = photo.getBoundingClientRect();
  const afterStyle = getComputedStyle(item, '::after');
  const rightOffset = parseFloat(afterStyle.right) || 0;
  const thumbWidth = parseFloat(afterStyle.width) || 6;
  const grabMargin = 8;
  const trackRight = itemRect.right - rightOffset + thumbWidth + grabMargin;
  const trackLeft = itemRect.right - rightOffset - grabMargin;
  if (
    clientX < trackLeft ||
    clientX > trackRight ||
    clientY < photoRect.top ||
    clientY > photoRect.bottom
  ) {
    return null;
  }
  return { text, trackTop: photoRect.top, trackHeight: photoRect.height };
};

document.addEventListener('mousedown', (e) => {
  const item = e.target.closest('.profile__item');
  if (!item) return;
  const target = getProfileDragTarget(item, e.clientX, e.clientY);
  if (!target) return;
  e.preventDefault();
  const { text, trackTop, trackHeight } = target;
  const scrollable = text.scrollHeight - text.clientHeight;
  const setScrollFromY = (clientY) => {
    const ratio = trackHeight > 0 ? (clientY - trackTop) / trackHeight : 0;
    text.scrollTop = Math.max(0, Math.min(1, ratio)) * scrollable;
  };
  setScrollFromY(e.clientY);
  profileDrag = { setScrollFromY };
});

document.addEventListener('mousemove', (e) => {
  if (!profileDrag) return;
  profileDrag.setScrollFromY(e.clientY);
});

document.addEventListener('mouseup', () => {
  profileDrag = null;
});
